import React from 'react'
import TitleWithIcon from '../TitleWithIcon'
import VisDiv from '../frontend_components/VisDiv'
import Divider from '../frontend_components/Divider'
import { TbNotesOff } from "react-icons/tb";


/**
 * DeviceFamily component
 * 
 * @param {Object} data - object containing deviceFamily and registerTemplateDevices
 * @param {Object} deviceFamily - object containing the device family to be displayed
 * @param {Array} registerTemplateDevices - array of register template devices
 * #offers
 * This component displays a device family, with an indication if it is not present in the register template devices.
 * When clicked, it logs the data and register template device to the console.
 */
   const DeviceFamily = ({data}) => {
      const {deviceFamily, registerTemplateDevices} = data 
      const [viewInfo, setViewInfo] = React.useState(false)
      const notInRegister = deviceFamily?.notInRegister
      const onRowClick = () => {
         console.log("DATA", data)
         console.log("registerTemplateDevice", registerTemplateDevice)
      } 
      //console.log("IN CONSOLE DEV FAMILY", registerTemplateDevices)
      const registerTemplateDevice = !Array.isArray(registerTemplateDevices) ? undefined : registerTemplateDevices?.find?.((x)=>x?._id == deviceFamily?.templateDeviceId)
      return (
         <div onClick={onRowClick} style={{backgroundColor: notInRegister && "orange", display:"flex"}} className='offer-device-family-header-container'>
            <h4 style={{marginLeft:"30px"}}>{registerTemplateDevice?.label}</h4>
            <VisDiv onClick={()=>setViewInfo(!viewInfo)} style={{marginLeft:"20px", cursor: "pointer"}} rules={[notInRegister]}>
               <TbNotesOff size={20} color={"white"} />
            </VisDiv>
            <VisDiv rules={[notInRegister, viewInfo]}>
               <p> Questa famiglia non è più presente nel registro</p>
            </VisDiv>
           
         </div>

       )
     }

export default DeviceFamily

